<template>
    <footer>
        <div id="footer-bottom">
            <div class="container-fluid container-max">
                
                <p id="footer-help">
                    <strong>Need help?</strong> Email <a href="mailto:registrar@illinois.edu">registrar@illinois.edu</a> or call <span class="keep-together">217-333-2034.</span> &nbsp;
                    <a :href="applicantLoginUrl">Log in as applicant.</a> 
                </p>
                

                <p id="copyright">&copy; Copyright University of Illinois Board&nbsp;of&nbsp;Trustees</p>
                <p id="privacy"><a href="https://www.vpaa.uillinois.edu/resources/web_privacy">Web Privacy Notice</a></p>
                
                <!--OneTrust Cookies Settings button start --><a class="optanon-show-settings">Cookie Settings</a><!--OneTrust Cookies Settings button end -->
            </div>
        </div>
    </footer>
</template>
<script>
    import { getMyIlliniUrl } from "@/common/envMixins";
    export default {
        name: 'Footer',
        computed: {
            applicantLoginUrl: function() {
                return `${getMyIlliniUrl()}/IdentityManagement/Home/ChangeLoginMethod/myIllini`;
            }
        }
        
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>